import styled from '@emotion/styled'
import tw from 'twin.macro'

const prefix = 'common'

export const ThemeCommon = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .${prefix}-web-title {
    z-index: 1;
    top: 93px;
    left: 100px;
    white-space: nowrap;
    ${tw`text-white-100 absolute font-size-2xl font-weight-bold`}
  }
  @media screen and (max-width: 768px) {
    .${prefix}-web-title {
      left: 50%;
      transform: translate(-50%, 0%);
      top: 72.97px;
    }
  }
  .${prefix}-background {
    ${tw`w-full h-full absolute top-0 left-0`}
  }
  .${prefix}-contentBox {
    right: 5.2%;
    top: 27.03%;
    z-index: 1;
    border-radius: 10px;
    background: #fff;
    ${tw`absolute flex`}
  }
  @media screen and (max-width: 768px) {
    .${prefix}-contentBox {
      top: 29%;
    }
  }
  .${prefix}-picture {
    width: 60%;
    padding: 30px;
    ${tw`h-full flex flex-col items-center justify-between hidden lg:block`}
  }
  .${prefix}-loginBox {
    ${tw`w-full h-full py-16 px-20 flex flex-col relative`}
  }
  @media screen and (max-width: 768px) {
    .${prefix}-loginBox {
      padding: 37px 30px;
    }
  }
  .${prefix}-login-title {
    ${tw`font-size-xl font-weight-bold text-gray-200 mb-10`}
  }
  @media screen and (max-width: 768px) {
    .${prefix}-login-title {
      font-size: 18px;
    }
  }
  .${prefix}-to-code-login {
    border: 50px solid var(--ow-color-primary-700);
    border-left: 50px solid transparent;
    border-bottom: 50px solid transparent;
    border-top-right-radius: 10px;
    width: 0;
    height: 0;
    top: 0;
    right: 0;
    > div {
      top: -35px;
      right: -31px;
      ${tw`absolute`}
    }
    ${tw`absolute`}
  }
  .${prefix}-tabBox {
    background: rgba(0, 86, 254, 0.1);
    ${tw`flex items-center justify-center p-1 rounded-3xl`}
  }
  .${prefix}-pwdButton {
    ${tw`rounded-3xl w-24 bg-transparent text-black font-medium`}
  }
  .${prefix}-codeButton {
    ${tw`rounded-3xl w-24 bg-transparent text-black font-medium`}
  }
  .${prefix}-activepwdButton {
    background: #0056fe;
    ${tw`text-white rounded-3xl w-24 font-medium`}
  }
  .${prefix}-activecodeButton {
    background: #0056fe;
    ${tw`text-white rounded-3xl w-24 font-medium`}
  }
  .${prefix}-loginBtn {
    height: 40px;
    ${tw`w-full bg-primary-700 text-white-100 mt-8`}
  }
  .${prefix}-registerBtn {
    min-width: 100px;
    margin-top: 70px;
    font-weight: 700;
    color: #0056fe;
    ${tw`bg-white rounded-3xl`}
  }
  .${prefix}-backBtn {
    min-width: 100px;
    margin-top: 70px;
    font-weight: 700;
    ${tw`bg-white rounded-3xl block lg:hidden`}
  }
  .${prefix}-inputGroupBox {
    ${tw`w-full rounded-md `}
  }
  .${prefix}-inputIcon {
    color: #8c8c8c;
  }
  .${prefix}-inputPhoneBox {
    > div {
      padding: 9px 8px;
      border: 1px solid var(--ow-color-neutral-400);
      ${tw`w-full rounded flex flex-row items-center`}
    }
    ${tw`mb-6`}
  }
  .${prefix}-inputPhone {
    font-size: 0.8125rem;
    ${tw`flex-1 focus:outline-none font-size-sm`}
  }
  .${prefix}-inputPwdBox {
    > div {
      padding: 9px 8px;
      border: 1px solid var(--ow-color-neutral-400);
      ${tw`w-full rounded flex flex-row items-center relative`}
    }
  }
  .${prefix}-inputPwd {
    font-size: 0.8125rem;
    ${tw`flex-1 focus:outline-none font-size-sm`}
  }
  .${prefix}-inputPass {
    color: #00aa33;
    margin-right: 20px;
  }
  .${prefix}-inputTitle {
    ${tw`font-size-md text-gray-100 mb-2`}
  }
  @media screen and (max-width: 768px) {
    .${prefix}-inputTitle {
      font-size: 14px;
    }
  }
  .${prefix}-error-tip {
    ${tw`text-error-500 font-size-xs`}
  }
  .${prefix}-codeBtn {
    border: 1px solid var(--ow-color-neutral-400);
    ${tw`rounded font-size-md text-gray-100`}
  }
  .${prefix}-icon {
    color: #8c8c8c;
  }
`
